import feedbackList from '@/store/modules/feedback/feedback-list'
import feedbackInfo from '@/store/modules/feedback/feedback-info'

export default {
  feedbackList,
  feedbackInfo,
}
